import React, { useState } from 'react'
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  LinearProgress
} from '@mui/material'

import { useParams } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux'
import { resetPassword } from '../../actions/userActions'

const ResetPassword = () => {
  const { token } = useParams()
  const [password, setPassword] = useState('')
  const dispatch = useDispatch()
  const { error, msg, loading } = useSelector(state => state.userState)


  const onSubmit = e => {
    e.preventDefault()
    dispatch(resetPassword(token, password))
  }

  return (
    <Card sx={{ maxWidth: 650, mx: 'auto', mt: 5 }}>
      {loading && <LinearProgress />}
      <CardContent sx={{ p: 3 }}>
        <Typography variant='h6' sx={{ mb: 2 }}>Reset your password</Typography>
        <Typography>Enter your desired password.</Typography>
        <form onSubmit={onSubmit}>
          {error && <Alert severity='error' sx={{ mt: 1 }}>{error}</Alert>}
          {msg && <Alert severity='info' sx={{ mt: 1 }}>{msg}</Alert>}
          <TextField
            label='Password'
            fullWidth
            sx={{ my: 3 }}
            value={password}
            type='password'
            onChange={e => setPassword(e.target.value)}
          />
          <Button type='submit' variant='contained' fullWidth>Submit</Button>
        </form>
      </CardContent>
    </Card>
  )
}

export default ResetPassword